import React from "react";
import styles from "./HomeMenuCard.module.css";
import Redirect from "../../../utils/Redirect";
import { FaWarehouse } from "react-icons/fa";

export default function HomeMenuCard({ image, title, url, categoryId }) {
  const imageColor =
    categoryId === 1
      ? styles.sterilization
      : categoryId === 2
      ? styles.washing
      : categoryId === 3
      ? styles.hygieneMonitoring
      : categoryId === 4
      ? styles.dispatch
      : styles.reception;

  return (
    <div
      className={styles.card}
      onClick={() =>
        Redirect({
          redirect: true,
          path: url,
        })
      }
    >
      <div className={`${styles.imageContainer} ${imageColor}`}>
        <img src={image} className={styles.image} alt={title} />
      </div>
      <p className={styles.title}>{title}</p>
    </div>
  );
}
